import request, { ResponsePageableData } from '@/libs/request'

/** 设置模型字段 */
export const getNoticeLogList = (data?) => request<ResponsePageableData>({ url: '/adminapi/Notice/getNoticeLogList', data })

export const noticeToAll = (data?) => request<ResponsePageableData>({ url: '/adminapi/Notice/noticeToAll', data })
